import React from 'react';
import PropTypes from 'prop-types';

import FilterNumberPair from 'components/search_sidebar/filter_number_pair';
import FilterDatePickerPair from 'components/search_sidebar/filter_datepicker_pair';
import { CalendarPortal } from 'components/form/managed_input/date_input';

import {
  filterLabelMappings,
  filterKeyMappings,
} from 'bundles/research/index/research_constants';
import { Col, Row } from 'react-bootstrap-5';

export default class SaleFilterGroup extends React.Component {
  static propTypes = {
    compsView: PropTypes.bool,
    saleFilter: PropTypes.object.isRequired,
    onFilterChange: PropTypes.func.isRequired,
  };

  render() {
    const { saleFilter, onFilterChange } = this.props;

    return (
      <div className="d-flex flex-column gap-2">
        <Row>
          <Col>
            <FilterNumberPair
              filter={saleFilter}
              label={filterLabelMappings['salesPrice']}
              valueKeys={filterKeyMappings['salesPrice']}
              onChange={onFilterChange}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <FilterDatePickerPair
              filter={saleFilter}
              label={filterLabelMappings['salesDate']}
              popperContainer={CalendarPortal}
              valueKeys={filterKeyMappings['salesDate']}
              onChange={onFilterChange}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <FilterNumberPair
              filter={saleFilter}
              label={filterLabelMappings['sfPrice']}
              valueKeys={filterKeyMappings['sfPrice']}
              onChange={onFilterChange}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <FilterNumberPair
              filter={saleFilter}
              label={filterLabelMappings['unitPrice']}
              valueKeys={filterKeyMappings['unitPrice']}
              onChange={onFilterChange}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <FilterNumberPair
              filter={saleFilter}
              label={filterLabelMappings['capRate']}
              valueKeys={filterKeyMappings['capRate']}
              onChange={onFilterChange}
            />
          </Col>
        </Row>
      </div>
    );
  }
}
